module.exports = __webpack_public_path__ + "img/en.c1fa84f3.png";